const Teacher = () => {
    return (
   


  <div className="navigation-buttons" style={{  marginTop: '2%'}}>
  <button style={{ backgroundColor: '#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px'}}>
    <a href='/Teacher' style={{ textDecoration: 'none', color: 'white' }}>My Course</a>
  </button>
  <button style={{ backgroundColor:'#03396c', color: 'white', border: 'none', padding: '10px 30px', borderRadius: '4px', margin: '5px' }}>
    <a href='/Online' style={{ textDecoration: 'none', color: 'white' }}>Online Course</a>
  </button>
  <button style={{ backgroundColor:'#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px' }}>
    <a href='/Assessment' style={{ textDecoration: 'none', color: 'white' }}>My Assessment</a>
  </button>
</div>
  );
};








 


  const


   Hed = () => {
    return (
      <div>
     <Teacher/>
      </div>
    );
  };
 
  export default Hed;

